import { useIntl } from 'react-intl';

import messages from '@app/components/StoreSwitch/StoreSwitch.messages';

const LocationIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const intl = useIntl();

  return (
    <svg
      width="12"
      viewBox="0 0 11 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{intl.formatMessage(messages.location)}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 13C7.433 13 10 8.08985 10 4.5C10 0.91015 7.433 0 5.5 0C3.567 0 1 0.91015 1 4.5C1 8.08985 3.567 13 5.5 13ZM5.5 6C6.32843 6 7 5.32843 7 4.5C7 3.67157 6.32843 3 5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6Z"
        fill="#222222"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 13C6.77159 13 6.38844 13 5.5 13C4.61156 13 4.5 13 3.5 13C2.89676 12.3921 2.11199 11.4572 1.64045 10.5624C0.702498 8.78258 0 6.49743 0 4.50001C0 2.43728 0.836869 0.890445 2 4.74229e-06C3 0 4.40143 0 5.5 0C6.59857 0 7.5 0 9 4.74229e-06C10.1631 0.890445 11 2.43728 11 4.50001C11 6.49743 10.2975 8.78258 9.35955 10.5624C8.88801 11.4572 8.10324 12.3921 7.5 13ZM5.5 5.00001C5.77614 5.00001 6 4.77615 6 4.50001C6 4.22387 5.77614 4.00001 5.5 4.00001C5.22386 4.00001 5 4.22387 5 4.50001C5 4.77615 5.22386 5.00001 5.5 5.00001ZM10 4.50001C10 8.08986 7.433 13 5.5 13C3.567 13 1 8.08986 1 4.50001C1 0.910164 3.567 0 5.5 0C7.433 0 10 0.910164 10 4.50001ZM7 4.50001C7 5.32844 6.32843 6.00001 5.5 6.00001C4.67157 6.00001 4 5.32844 4 4.50001C4 3.67158 4.67157 3.00001 5.5 3.00001C6.32843 3.00001 7 3.67158 7 4.50001Z"
        fill="white"
      />
    </svg>
  );
};

export default LocationIcon;
